import { Pipe, PipeTransform } from '@angular/core';
import { beautifyCamelCaseString } from 'src/app/common/stringUtils';
import { RuleTag } from 'src/app/models/api/governance/violationRule.model';

@Pipe({
  name: 'ruleTagDisplayName',
})
export class RuleTagDisplayNamePipe implements PipeTransform {
  /**
   * A pipe to beautify displayed snake_case or camelCase strings in UI
   * For single words it capitalizes first letter: vulnERAbility -> Vulnerability
   * For concatenated words with "_": data_flow -> Data Flow
   * For camelCase words: dataFlow -> Data Flow
   * For PascalCase words: DataFlow -> Data Flow
   */

  public transform(value: string | RuleTag): string {
    const temp = value.toString();
    if (temp === 'generalAvailability') return 'GA';
    return beautifyCamelCaseString(temp);
  }
}
